import clsx from "clsx"
import type { HTMLAttributes } from "react"
import { useTranslation } from "react-i18next"
import { cn } from "@/shared/lib/utils.ts"
import { type IconProps, Loader } from "../ui/icons"

interface IProps extends HTMLAttributes<HTMLDivElement> {
  loaderProps?: IconProps
}

export default function Spinner({ className, loaderProps }: IProps) {
  const { t } = useTranslation("common")
  return (
    <div className={clsx("flex h-full w-full items-center justify-center gap-2 bg-paper", className)}>
      <Loader
        size={20}
        {...loaderProps}
        className={cn("flex animate-spin *:fill-blue-600", loaderProps?.className)}
        style={{
          animationDuration: ".4s"
        }}
      />
      {t("loading")}...
    </div>
  )
}
